import React from 'react';
import pdfLogo from '../../assets/General/pdf.png';
import "./DownloadFile.css"

const DownloadFile = ({ fileName, fileUrl }) => {
  const handleDownload = () => {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  };

  return (
    <div className="download-div" onClick={handleDownload}>
      <img src={pdfLogo} id="png-logo" alt="download" />
      <div className="download-text">
        <div className="download-filename">
          <b>{fileName}</b>
        </div>
        <div className="download-file">
          <b>Download file</b>
        </div>
      </div>
    </div>
  );
};

export default DownloadFile;
